import { Box, Typography } from '@mui/material'

export const FormError = ({ message }: { message: string }) => {
  return (
    <Box display="flex" alignItems="center" px={0.5}>
      <Box
        width={4}
        height={20}
        borderRadius={12}
        bgcolor="error.main"
        mr={1}
      />

      <Typography variant="caption2" color="error.main">
        {message}
      </Typography>
    </Box>
  )
}
